export default __webpack_public_path__ + "static/self-app-next-b688ebcebcf33efc4677fafac3bca126.jpg";